/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getEligibility} from '../api'

 export const useQueryGetEligibility = createReactQueryHook('getEligibility', getEligibility)
